"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AnswerKey_exports = {};
__export(AnswerKey_exports, {
  default: () => AnswerKey_default
});
module.exports = __toCommonJS(AnswerKey_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 14C18 14.1172 17.9609 14.2148 17.8828 14.293C17.8047 14.3711 17.707 14.4102 17.5898 14.4102C17.4727 14.4102 17.3685 14.3711 17.2773 14.293C17.1992 14.2148 17.1602 14.1172 17.1602 14V13.5898H16.3398V14C16.3398 14.1172 16.2943 14.2148 16.2031 14.293C16.125 14.3711 16.0273 14.4102 15.9102 14.4102C15.793 14.4102 15.6953 14.3711 15.6172 14.293C15.5391 14.2148 15.5 14.1172 15.5 14V13.5898H14.6602V14C14.6602 14.1172 14.6211 14.2148 14.543 14.293C14.4648 14.3711 14.3672 14.4102 14.25 14.4102C14.1328 14.4102 14.0352 14.3711 13.957 14.293C13.8789 14.2148 13.8398 14.1172 13.8398 14V12.75C13.8398 12.5156 13.918 12.3203 14.0742 12.1641C14.2435 11.9948 14.4388 11.9102 14.6602 11.9102V11.0898L10.4219 11.0703C10.2266 12.0339 9.74479 12.8346 8.97656 13.4727C8.22135 14.0977 7.34245 14.4102 6.33984 14.4102C5.75391 14.4102 5.21354 14.306 4.71875 14.0977C4.21094 13.8763 3.76823 13.5768 3.39062 13.1992C3.01302 12.8216 2.71354 12.3789 2.49219 11.8711C2.27083 11.3633 2.16016 10.8229 2.16016 10.25C2.16016 9.67708 2.27083 9.13672 2.49219 8.62891C2.71354 8.12109 3.01302 7.67839 3.39062 7.30078C3.76823 6.92318 4.21094 6.6237 4.71875 6.40234C5.21354 6.19401 5.75391 6.08984 6.33984 6.08984C7.34245 6.08984 8.22135 6.40885 8.97656 7.04688C9.74479 7.67188 10.2266 8.46615 10.4219 9.42969L10.5 9.41016H18C18.2344 9.41016 18.4297 9.49479 18.5859 9.66406C18.7552 9.82031 18.8398 10.0156 18.8398 10.25C18.8398 10.4844 18.7552 10.6862 18.5859 10.8555C18.4297 11.0117 18.2344 11.0898 18 11.0898H17.1602V11.9102C17.3945 11.9102 17.5898 11.9948 17.7461 12.1641C17.9154 12.3203 18 12.5156 18 12.75V14ZM6.33984 7.75C5.64974 7.75 5.05729 7.9974 4.5625 8.49219C4.08073 8.97396 3.83984 9.5599 3.83984 10.25C3.83984 10.9401 4.08073 11.5326 4.5625 12.0273C5.05729 12.5091 5.64974 12.75 6.33984 12.75C7.02995 12.75 7.61589 12.5091 8.09766 12.0273C8.59245 11.5326 8.83984 10.9401 8.83984 10.25C8.83984 9.5599 8.59245 8.97396 8.09766 8.49219C7.61589 7.9974 7.02995 7.75 6.33984 7.75Z",
      fill: "currentColor"
    }
  )
);
const SvgAnswerKey = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AnswerKey_default = SvgAnswerKey;
